import React from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import TabContentWrapper from '../TabContentWrapper';
import MediaDescription from '../../details/MediaDescription';
import {EmptyState, TscButtonType, TscThemeNames} from '@techsmith/tsc-cloud-style-guide';
import EditDetailsModal from '../../details/EditDetailsModal';
import config from '../../../service/config';
import withMemoizedContexts from '../../../context/contextContainerHoC';
import {themeStore} from '../../../context/themeProvider';
import {mediaStore} from '../../../context/mediaProvider';

const EmptyStateWrapper = styled.div`
   display: flex;
   justify-content: center;
   align-items: center;
   width: 100%;
   margin: 3rem 0;
`;

export const DetailsTabBase: React.FC<IStateMappedProps> = ({theme, Description, IsReady}) => {
   const {t} = useTranslation();
   const [showEditDetailsModal, setShowEditDetailsModal] = React.useState(false);

   const emptyState =
      (<EmptyStateWrapper>
         <EmptyState
            title={t('details.tabEmptyState.title')}
            text={t('details.tabEmptyState.text')}
            primaryButtonText={t('details.tabEmptyState.buttonText')}
            primaryButtonType={TscButtonType.secondary}
            onPrimaryClick={IsReady && config.watchConfig.isOwnerOrAdmin ? () => setShowEditDetailsModal(true) : null}
            themeName={theme}
            maxWidth="100%"
         />
      </EmptyStateWrapper>)
   ;

   const nonEmptyState = <MediaDescription rawDescriptionText={Description}/>;

   return (
      <>
         <TabContentWrapper showSpinner={false} showError={false}>
            {Description ? nonEmptyState : emptyState}
         </TabContentWrapper>
         {showEditDetailsModal && <EditDetailsModal onClose={() => setShowEditDetailsModal(false)} />}
      </>
   );
};

export interface IStateMappedProps {
   theme: TscThemeNames;
   Description: string;
   IsReady: boolean;
}

const mapStatesToProps = (
   // eslint-disable-next-line no-empty-pattern
   {},
   {theme}: Partial<IStateMappedProps>,
   {Description, IsReady}: Partial<IStateMappedProps>
): IStateMappedProps => ({theme, Description, IsReady});

export default withMemoizedContexts(mapStatesToProps, themeStore, mediaStore)(DetailsTabBase);
